import projectImg_2 from "../../assets/images/contract-type/contract-type-2.jpg";
import projectImg_5 from "../../assets/images/contract-type/contract-type-5.jpg";
import projectImg_7 from "../../assets/images/contract-type/contract-type-7.jpg";
import projectImg_9 from "../../assets/images/contract-type/contract-type-9.jpg";
import projectImg_10 from "../../assets/images/contract-type/contract-type-10.jpg";

export  const projectData = [
  {
    id: 1,
    project_name: "勞動契約",
    details: "適用於雇主僱用勞工（員工）。",
    src: projectImg_2
  },
  {
    id: 2,
    project_name: "房屋租賃契約",
    details: "適用於出租、承租房屋。",
    src: projectImg_5
  },
  {
    id: 3,
    project_name: "合夥契約",
    details: "適用於合夥人出資共同成立「合夥事業」",
    src: projectImg_7
  },
  {
    id: 4,
    project_name: "投資協議書",
    details: "適用於投資人投資已經設立的「股份有限公司」。",
    src: projectImg_9
  },
  {
    id: 5,
    project_name: "借貸契約",
    details: "適用於借貸金錢、房屋、車輛或其他物品。",
    src: projectImg_10
  },

]